var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44503 0.724953L10.445 2.72495C10.6116 2.80774 10.7518 2.93537 10.8499 3.09347C10.9479 3.25158 10.9999 3.43391 11 3.61995V8.38495C10.9999 8.57099 10.9479 8.75332 10.8499 8.91143C10.7518 9.06954 10.6116 9.19716 10.445 9.27995L6.44503 11.28C6.3061 11.3495 6.15288 11.3857 5.99752 11.3857C5.84217 11.3857 5.68896 11.3495 5.55003 11.28L1.55002 9.27995C1.38359 9.19609 1.2439 9.06739 1.14672 8.90836C1.04954 8.74934 0.998727 8.56632 1.00002 8.37995V3.61995C1.00012 3.43391 1.05212 3.25158 1.15016 3.09347C1.24821 2.93537 1.38842 2.80774 1.55502 2.72495L5.55502 0.724953C5.6933 0.656241 5.84562 0.620483 6.00002 0.620483C6.15443 0.620483 6.30675 0.656241 6.44503 0.724953V0.724953Z",
    stroke: "#191919",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15991 3.07996L5.99991 5.49996L10.8399 3.07996",
    stroke: "#191919",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.38V5.5",
    stroke: "#191919",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.a9c09c88a4e0754f416b7e4c76a43f07.svg";
export { ForwardRef as ReactComponent };